import { render, staticRenderFns } from "./TagPicker.vue?vue&type=template&id=5900fab8&scoped=true"
import script from "./TagPicker.vue?vue&type=script&lang=ts"
export * from "./TagPicker.vue?vue&type=script&lang=ts"
import style0 from "./TagPicker.vue?vue&type=style&index=0&id=5900fab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5900fab8",
  null
  
)

export default component.exports